module.exports = __webpack_public_path__ + "img/phone-balance.b524b2b7.webp";